module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-modal', {
    attrs: {
      "id": "image-modal",
      "name": "image-modal",
      "title": _vm.modalImageFilename,
      "size": "lg",
      "hide-footer": ""
    }
  }, [_c('b-img', {
    attrs: {
      "fluid": "",
      "src": _vm.modalImageUrl
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d9eaf6f6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modals/PreviewImageModal.vue
// module id = 1028
// module chunks = 1